import React, { useState } from 'react'
import { Button } from '@chakra-ui/react'
import { Box, Flex } from '@chakra-ui/react'
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react'

import { useTeamChatConversation } from '../../provider'
import SharedLabel from '~components/shared/form/shared-label'
import {
    getDefaultChatTitle,
    InternalChatTitle,
} from '~components/team-chat/layout/sidebar/chat-item'
import SharedStack from '~components/shared/wrappers/shared-stack'
import {
    namedOperations,
    useUpdateInternalChatMutation,
} from '~graphql/generated/graphql'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'

export default function TeamChatTitleEdit() {
    const { internalChat, internalChatUsers } = useTeamChatConversation()

    const [isEditing, setIsEditing] = useState(false)
    const [title, setTitle] = useState(internalChat.title || '')

    const { onCompleted, onError } = useToastFeedback(
        'Chat title updated successfully!',
        'Failed to update chat title.',
    )

    const [updateInternalChat] = useUpdateInternalChatMutation({
        onCompleted,
        onError,
        refetchQueries: [namedOperations.Query.internalChatUsers],
        awaitRefetchQueries: true,
    })

    async function handleSave() {
        try {
            await updateInternalChat({
                variables: {
                    id: internalChat.id,
                    data: {
                        title: title.trim(),
                    },
                },
            })
            setIsEditing(false)
        } catch (error) {
            console.error('Failed to update chat title:', error)
            // Optionally, you can show an error message to the user
        }
    }

    if (isEditing) {
        return (
            <InputGroup variant="filled" size="sm">
                <Input
                    h="48px"
                    px={4}
                    rounded="md"
                    autoFocus
                    value={title}
                    placeholder={getDefaultChatTitle(
                        internalChatUsers.map(u => u.user),
                    )}
                    onChange={e => setTitle(e.target.value)}
                />
                <InputRightElement h="48px" w="fit-content" px={3}>
                    <SharedStack row fit>
                        <Button
                            size="xs"
                            onClick={() => {
                                setIsEditing(false)
                                setTitle(internalChat.title || '')
                            }}
                            variant="ghost"
                        >
                            Cancel
                        </Button>
                        <Button
                            size="xs"
                            variant="solid"
                            colorScheme="brand"
                            onClick={handleSave}
                            isDisabled={title === (internalChat.title || '')}
                        >
                            Save
                        </Button>
                    </SharedStack>
                </InputRightElement>
            </InputGroup>
        )
    }

    return (
        <Flex
            py={2}
            px={3}
            align="center"
            justify="space-between"
            bg="gray.100"
            rounded="lg"
            borderWidth={1}
            borderColor="gray.300"
        >
            <Box>
                <SharedLabel fontWeight="medium">Title</SharedLabel>
                <InternalChatTitle
                    chat={internalChat}
                    users={internalChatUsers}
                    labelOverrides={{
                        fontSize: 'sm',
                        fontWeight: 'normal',
                    }}
                />
            </Box>
            <Button
                variant="ghost"
                colorScheme="gray"
                size="xs"
                onClick={() => setIsEditing(true)}
            >
                Edit
            </Button>
        </Flex>
    )
}
